import React from "react";
import ReusableModal from "./ReusableModal";
import FormButton from "../form/FormButton";

const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "danger",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <ReusableModal
      open={open}
      title={title}
      onClose={onCancel}
      width="520px"
      closeOnBackdrop={false}
      className="confirm-dialog-modal"
    >
      <div className="cd-wrap">
        <p className="cd-message">{message}</p>

        <div className="promo-actions">
          <FormButton
            type="button"
            variant="secondary"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </FormButton>

          <FormButton
            type="button"
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Please wait..." : confirmText}
          </FormButton>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ConfirmDialog;